import React from 'react';

import { Typography } from 'src/typography';
import { useInstoreEnrollment } from 'src/hooks/use-instore-enrollment';
import { InstoreEnrollmentStatus } from 'src/state/instore-enrollment';
import { CenteredColumn, StepPanel, StepFooter, StepButton } from '../shared-components';

type SubmittedStepProps = {
  isSubmitting: boolean;
  submissionError: string | null;
  submissionSuccess: boolean;
};

export const SUBMITTING_FORM_TEXT = 'Submitting form';
export const SUBMISSION_FAILED_TEXT = 'Submission Failed';
export const FORM_SUBMITTED_TEXT = 'Form Submitted!';
export const PROCESSING_TEXT = 'Processing...';

export const SubmittedStep = ({
  isSubmitting,
  submissionError,
  submissionSuccess,
}: SubmittedStepProps): JSX.Element => {
  const instoreEnrollment = useInstoreEnrollment();
  if (isSubmitting) {
    return (
      <StepPanel>
        <CenteredColumn>
          <Typography.Heading tag='h2' size='medium'>
            {SUBMITTING_FORM_TEXT}
          </Typography.Heading>
        </CenteredColumn>
      </StepPanel>
    );
  }

  if (submissionError) {
    return (
      <>
        <StepPanel>
          <CenteredColumn>
            <Typography.Heading tag='h2' size='medium' color='error'>
              {SUBMISSION_FAILED_TEXT}
            </Typography.Heading>
            <Typography.Body size='medium'>{submissionError}</Typography.Body>
          </CenteredColumn>
        </StepPanel>
        <StepFooter>
          <StepButton onClick={() => window.location.reload()} variant='outlinePrimary'>
            Try Again
          </StepButton>
        </StepFooter>
      </>
    );
  }

  if (submissionSuccess) {
    return (
      <>
        <StepPanel>
          <CenteredColumn>
            <Typography.Heading tag='h2' size='medium' color='success'>
              {FORM_SUBMITTED_TEXT}
            </Typography.Heading>
          </CenteredColumn>
        </StepPanel>
        <StepFooter>
          <StepButton onClick={() => instoreEnrollment.setCurrentStatus(InstoreEnrollmentStatus.loyaltyEnrollment)}>
            Continue to Loyalty Program
          </StepButton>
        </StepFooter>
      </>
    );
  }

  // Fallback state - shouldn't normally reach here
  return (
    <StepPanel>
      <CenteredColumn>
        <Typography.Heading tag='h2' size='medium'>
          {PROCESSING_TEXT}
        </Typography.Heading>
      </CenteredColumn>
    </StepPanel>
  );
};
